import { render, staticRenderFns } from "./groupRegular.vue?vue&type=template&id=584824bf&"
import script from "./groupRegular.vue?vue&type=script&lang=js&"
export * from "./groupRegular.vue?vue&type=script&lang=js&"
import style0 from "./groupRegular.vue?vue&type=style&index=0&id=584824bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports